import BaseInput from "../components/black_dashboard_pro/Inputs/BaseInput.vue";
import BaseDropdown from "../components/black_dashboard_pro/BaseDropdown.vue";
import Card from "../components/black_dashboard_pro/Cards/Card.vue";
import BaseButton from "../components/black_dashboard_pro/BaseButton.vue";
import BaseCheckbox from "../components/black_dashboard_pro/Inputs/BaseCheckbox.vue";
import { Input, InputNumber, Tooltip, Popover } from "element-ui";
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue: any) {
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(Card.name, Card);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(Input.name, Input);
    Vue.component(InputNumber.name, InputNumber);
    Vue.use(Tooltip);
    Vue.use(Popover);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  }
};

export default GlobalComponents;
